module.exports = __webpack_public_path__ + "img/download_light_icon.d9c3d201.svg";